import { render } from "./PassComments.vue?vue&type=template&id=4a596e02"
import script from "./PassComments.vue?vue&type=script&lang=js"
export * from "./PassComments.vue?vue&type=script&lang=js"

import "./PassComments.vue?vue&type=style&index=0&id=4a596e02&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__